import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=e3f3e0ee&scoped=true&"
import script from "./LabelSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=e3f3e0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f3e0ee",
  null
  
)

export default component.exports